import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const H1 = styled.h1`
  font-size: ${fontSize.xxl};
`;

export default H1;
